import React from "react";
import { SbModal, SbButton, SbTag, WarningFilled } from "uiCore";
import {
  PAIC_INVALID_JOBS_CONTENT,
  PAIC_NON_COMPENSATION_ISSUES,
  getPAICJobIssueLabel,
} from "constants/peoplePlusAI.constants";
import {
  InvalidJobsTitleRow,
  InvalidJobsTitleIcon,
  InvalidJobsMessage,
  InvalidJobsList,
  InvalidJobItem,
  InvalidJobName,
  InvalidJobReq,
  InvalidJobIssues,
  InvalidJobsFooter,
} from "./InvalidJobsModal.styles";

/**
 * Lists the selected jobs that blocked a PAIC run and what needs fixing on
 * each (compensation, position count, or both). Driven by the backend's
 * synchronous `invalid_jobs` response — see getPAICInvalidJobs.
 */
const InvalidJobsModal = ({ validation, onClose }) => (
  <SbModal
    open={Boolean(validation)}
    onCancel={onClose}
    centered
    width={560}
    className="paic-confirm-modal"
    title={
      <InvalidJobsTitleRow>
        <InvalidJobsTitleIcon>
          <WarningFilled />
        </InvalidJobsTitleIcon>
        {PAIC_INVALID_JOBS_CONTENT.TITLE}
      </InvalidJobsTitleRow>
    }
    footer={
      <SbButton buttonType="primary" onClick={onClose}>
        OK
      </SbButton>
    }
  >
    {validation && (
      <>
        <InvalidJobsMessage>{validation.message}</InvalidJobsMessage>
        <InvalidJobsList>
          {validation.invalidJobs.map((job, index) => (
            <InvalidJobItem key={job.sb_unique_id || index}>
              <div>
                <InvalidJobName>{job.job_title || job.sb_unique_id || "Unknown job"}</InvalidJobName>
                {job.sb_req && <InvalidJobReq>({job.sb_req})</InvalidJobReq>}
              </div>
              {job.issues.length > 0 && (
                <InvalidJobIssues>
                  {job.issues.map((issue) => (
                    <SbTag key={issue}>{getPAICJobIssueLabel(issue)}</SbTag>
                  ))}
                </InvalidJobIssues>
              )}
            </InvalidJobItem>
          ))}
        </InvalidJobsList>
        <InvalidJobsFooter>{PAIC_INVALID_JOBS_CONTENT.FOOTER}</InvalidJobsFooter>
        {validation.invalidJobs.some((job) =>
          job.issues.some((issue) => PAIC_NON_COMPENSATION_ISSUES.includes(issue)),
        ) && <InvalidJobsFooter>{PAIC_INVALID_JOBS_CONTENT.REMOVED_JOBS_NOTE}</InvalidJobsFooter>}
      </>
    )}
  </SbModal>
);

export default InvalidJobsModal;
